/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as axios from 'axios';
import type {
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  AssignPayoutPolicyDto,
  ListTalentMembersParams,
  PayeePayoutTermsDto,
  SetTalentMemberPushToCardDto,
  TalentMemberDto,
  TalentMemberDtoPaginatedResult,
  UpdateTalentMemberDto
} from '.././types';




  /**
 * **Required Permission(s):** ORG_PAYEE_GET
 */
export const getTalentMemberById = <TData = AxiosResponse<TalentMemberDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/talent-members/${id}`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYEE_UPDATE
 */
export const updateTalentMember = <TData = AxiosResponse<TalentMemberDto>>(
    id: string,
    updateTalentMemberDto: UpdateTalentMemberDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.put(
      `/api/talent-members/${id}`,
      updateTalentMemberDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYEE_DELETE
 */
export const deleteTalentMember = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.delete(
      `/api/talent-members/${id}`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYEE_LIST
 */
export const listTalentMembers = <TData = AxiosResponse<TalentMemberDtoPaginatedResult>>(
    params?: ListTalentMembersParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/talent-members`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * **Required Permission(s):** ORG_TALENT_SET_PUSH_TO_CARD
 */
export const setTalentMemberPushToCard = <TData = AxiosResponse<TalentMemberDto>>(
    id: string,
    setTalentMemberPushToCardDto: SetTalentMemberPushToCardDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.put(
      `/api/talent-members/${id}/push-to-card`,
      setTalentMemberPushToCardDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYEE_GET
 */
export const getTalentMemberPayoutTerms = <TData = AxiosResponse<PayeePayoutTermsDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/talent-members/${id}/payout-terms`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYEE_ASSIGN_PAYOUT_POLICY
 */
export const assignTalentMemberPayoutPolicy = <TData = AxiosResponse<PayeePayoutTermsDto>>(
    id: string,
    assignPayoutPolicyDto: AssignPayoutPolicyDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/talent-members/${id}/assign-payout-policy`,
      assignPayoutPolicyDto,options
    );
  }
export type GetTalentMemberByIdResult = AxiosResponse<TalentMemberDto>
export type UpdateTalentMemberResult = AxiosResponse<TalentMemberDto>
export type DeleteTalentMemberResult = AxiosResponse<void>
export type ListTalentMembersResult = AxiosResponse<TalentMemberDtoPaginatedResult>
export type SetTalentMemberPushToCardResult = AxiosResponse<TalentMemberDto>
export type GetTalentMemberPayoutTermsResult = AxiosResponse<PayeePayoutTermsDto>
export type AssignTalentMemberPayoutPolicyResult = AxiosResponse<PayeePayoutTermsDto>
